import { SearchOutlined } from '@ant-design/icons';
import { Button, Select, Tag } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { testCaseDifficultyMap } from './QuestionTab';

const { Option } = Select;
const BORDER_COLOR = '#d9d9d9';

const FilterBar = ({
  filters,
  setFilters,
  appliedSearchText,
  setAppliedSearchText,
  tagOptions,
}) => {
  const { t } = useTranslation('interview_container');

  const difficultyOptions = [
    { value: 'EZ', label: t('filter.difficulty.easy') },
    { value: 'MD', label: t('filter.difficulty.medium') },
    { value: 'HD', label: t('filter.difficulty.hard') },
  ];

  const handleTextSearch = () => setAppliedSearchText(filters.text);

  return (
    <div style={{ background: 'white', padding: '16px' }}>
      <h3 style={{ display: 'flex', fontSize: '20px', padding: '12px 0', fontWeight: 700 }}>
        {t('filter.title')}
      </h3>

      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
        {/* Search */}
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            placeholder={t('filter.search_placeholder')}
            style={{
              padding: '8px 40px 8px 28px',
              border: `1px solid ${BORDER_COLOR}`,
              borderRadius: '4px',
              fontSize: '14px',
              width: '632px',
              outline: 'none',
            }}
            value={filters.text}
            onChange={e => {
              const value = e.target.value;
              setFilters(prev => ({ ...prev, text: value }));
              setAppliedSearchText(value);
            }}
          />
          <SearchOutlined
            style={{
              position: 'absolute',
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
            }}
            onClick={handleTextSearch}
          />
        </div>

        {/* Difficulty */}
        <Select
          placeholder={t('filter.difficulty.label')}
          style={{ width: '11vw', height: 34 }}
          value={filters.difficulty || undefined}
          onChange={val => setFilters(prev => ({ ...prev, difficulty: val || '' }))}
          allowClear
        >
          {difficultyOptions.map(opt => (
            <Option
              key={opt.value}
              value={opt.value}
            >
              {opt.label}
            </Option>
          ))}
        </Select>

        {/* Tags */}
        <Select
          mode="multiple"
          placeholder={t('filter.tags.label')}
          style={{ width: '11vw' }}
          value={filters.tags}
          onChange={val => setFilters(prev => ({ ...prev, tags: val || [] }))}
          allowClear
          showSearch
          optionFilterProp="children"
          maxTagCount={2}
          maxTagPlaceholder={omitted => t('filter.tags.more', { count: omitted.length })}
        >
          {tagOptions.map(opt => (
            <Option
              key={opt.value}
              value={opt.value}
            >
              {opt.label}
            </Option>
          ))}
        </Select>
      </div>

      {/* Active Filters */}
      {(appliedSearchText || filters.difficulty || filters.tags.length > 0) && (
        <div style={{ marginTop: '8px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {appliedSearchText && (
            <Tag
              closable
              onClose={() => {
                setAppliedSearchText('');
                setFilters(p => ({ ...p, text: '' }));
              }}
            >
              {t('filter.active.search', { value: appliedSearchText })}
            </Tag>
          )}

          {filters.difficulty && (
            <Tag
              closable
              onClose={() => setFilters(p => ({ ...p, difficulty: '' }))}
            >
              {t('filter.active.difficulty')}: {testCaseDifficultyMap[filters.difficulty]}
            </Tag>
          )}

          {filters.tags.map(tg => (
            <Tag
              key={tg}
              closable
              onClose={() => setFilters(p => ({ ...p, tags: p.tags.filter(x => x !== tg) }))}
            >
              {t('filter.active.tag')}: {tagOptions.find(opt => opt.value === tg)?.label || tg}
            </Tag>
          ))}

          <Button
            type="link"
            size="small"
            onClick={() => {
              setFilters({ text: '', difficulty: '', tags: [] });
              setAppliedSearchText('');
            }}
          >
            {t('filter.clear_all')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterBar;
